export default "/images/6068b7110699ee0cc60b6047b2d8f90e.avif";